// Cashflow helpers
// Assumptions:
// - Month is normalized to 30 days
// - Year is normalized to 365 days
// This keeps the math stable and predictable for UI statistics.

export const CASHFLOW_PERIODS = [
  'DAILY',
  'WEEKLY',
  'BIWEEKLY',
  'TRIWEEKLY',
  'MONTHLY',
  'BIMONTHLY',
  'QUARTERLY',
  'YEARLY',
];

export const CASHFLOW_PAYMENT_TYPES = ['CASH', 'CARD', 'PRIVATE', 'COMPANY', 'VAT'];

export function periodToDays(period) {
  switch (String(period || '').toUpperCase()) {
    case 'DAILY':
      return 1;
    case 'WEEKLY':
      return 7;
    case 'BIWEEKLY':
      return 14;
    case 'TRIWEEKLY':
      return 21;
    case 'MONTHLY':
      return 30;
    case 'BIMONTHLY':
      return 60;
    case 'QUARTERLY':
      return 90;
    case 'YEARLY':
      return 365;
    default:
      return NaN;
  }
}

export function normalizeCashflow(amountPerPeriod, period) {
  const amount = Number(amountPerPeriod);
  const days = periodToDays(period);
  if (!Number.isFinite(amount) || !Number.isFinite(days) || days <= 0) {
    return { perDay: 0, perWeek: 0, perMonth: 0, perYear: 0, ok: false };
  }

  const perDay = amount / days;
  return {
    perDay,
    perWeek: perDay * 7,
    perMonth: perDay * 30,
    perYear: perDay * 365,
    ok: true,
  };
}

export function formatMoney(n, fractionDigits = 2) {
  const x = Number(n);
  if (!Number.isFinite(x)) return '';
  return x.toFixed(fractionDigits);
}
